// extracted by mini-css-extract-plugin
export var dividerContainer = "_7z-0";
export var line = "_7z-1";